import { SiglaProps } from './types'
import { Container } from './styles'

export function Sigla ({
  children,
  reporte_obrigatorio,
  requer_atencao,
  size
}: SiglaProps) {
  return (
    <Container
      reporte_obrigatorio={reporte_obrigatorio}
      requer_atencao={requer_atencao}
      size={size}
    >
      <span className="Sigla">{children}</span>
    </Container>
  )
}
